import { graphql, HttpResponse } from 'msw'
import {
  type EnrollmentMultiDocumentVerificationData,
  type EnrollmentMultiDocumentVerificationSubmitOutput,
} from '../../../../models'
import { DocumentVerificationStatus } from '../../../../models/enrollment/enrollment'

export const getEnrollmentMultiDocumentVerificationDataMockV2: EnrollmentMultiDocumentVerificationData = {
  __typename: 'SubmitEnrollmentSuccess',
  path: '/enrollment/multi/document-verification',
  enrollmentData: {
    applicationId: '123',
  },
}

export const submitEnrollmentMultiDocumentVerificationDataMockV2: EnrollmentMultiDocumentVerificationSubmitOutput = {
  __typename: 'SubmitEnrollmentSuccess',
  path: '/enrollment/multi/next-page-here',
}

let callCount = 0

export const submitEnrollmentMultiSDocVerificationCheckStatusDataMockV2 = () => {
  callCount++

  return {
    __typename: 'SubmitEnrollmentSuccess',
    path: '/enrollment/hycs/document-verification-complete',
    documentVerificationStatus:
      callCount >= 3 ? DocumentVerificationStatus.Complete : DocumentVerificationStatus.Pending,
    documentVerificationUrl: 'https://example.com',
  }
}

export const mockGetEnrollmentMultiDocumentVerificationDataV2 = graphql.mutation(
  'getEnrollmentMultiDocumentVerificationData',
  () => {
    return HttpResponse.json({ data: { submitEnrollment: getEnrollmentMultiDocumentVerificationDataMockV2 } })
  },
)

export const mockSubmitEnrollmentMultiDocumentVerificationDataV2 = graphql.mutation(
  'submitEnrollmentMultiDocumentVerificationData',
  () => {
    return HttpResponse.json({ data: { submitEnrollment: submitEnrollmentMultiDocumentVerificationDataMockV2 } })
  },
)

export const mockSubmitEnrollmentMultiDocVerificationCheckStatusDataV2 = graphql.mutation(
  'submitEnrollmentMultiDocVerificationCheckStatusData',
  () => {
    return HttpResponse.json({
      data: { submitEnrollment: submitEnrollmentMultiSDocVerificationCheckStatusDataMockV2() },
    })
  },
)

export const mockEnrollmentMultiDocumentVerificationV2 = [
  mockGetEnrollmentMultiDocumentVerificationDataV2,
  mockSubmitEnrollmentMultiDocumentVerificationDataV2,
  mockSubmitEnrollmentMultiDocVerificationCheckStatusDataV2,
]
